<template>
  <el-row class="wrap">
    <el-select v-model="$i18n.locale" @change="changeLanguage" size="small" class="lang-btn">
      <el-option
        v-for="item in langs"
        :key="item.value"
        :label="item.text"
        :value="item.value">
      </el-option>
    </el-select>
   <el-col :md="8" :sm="16" :xs="24">
      <div class="inner-wrap">
        <div class="text-top">
          <div class="logo-box">
            <img src="/static/logo360tovisit.png" alt="" width="185px">
          </div>
          <p class="slogan">{{ $t('Welcome back') }}!</p>
        </div>
        <el-form :model="userInfo" :rules="rules" ref="loginForm" @submit.native.prevent class="form-login">
          <el-form-item label="" prop="email">
            <el-input v-model="userInfo.email" prefix-icon="fa fa-user" class="input-form" :placeholder="$t('Email or Username')"></el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input type="password" v-model="userInfo.password" prefix-icon="fa fa-unlock-alt" class="input-form" :placeholder="$t('Password')"></el-input>
          </el-form-item>
          <el-button class="submit-btn" :loading="!canSubmit" @click="submitForm('loginForm')" native-type="submit">{{ $t('Log in') }}</el-button>
          <el-button class="submit-btn fb-btn" @click="loginFacebook" style="margin: 10px 0px 0px 0px; background-color: #516eab;"><i class="fa fa-facebook"></i>  {{ $t('Log in with Facebook') }}</el-button>
          <g-signin-button
            :params="googleSignInParams"
            @success="googleSignInSuccess"
            @error="googleSignInError">
            <i class="fa fa-google"></i>
            <span>{{ $t('Log in with Google') }}</span>
          </g-signin-button>
          <div class="text-bottom">
            <span class="text-center" @click="registerNow()">{{ $t('Create your account') }}</span>
          </div>
          <div class="text-bottom">
            <span class="text-center" @click="showForgotPassword = true">{{ $t('Forgot your password?') }}</span>
          </div>
          <div class="text-bottom">
            <span class="text-center" @click="showActiveAccount = true">{{ $t('Your account is not actived? Active now!') }}</span>
          </div>
        </el-form>
      </div>
   </el-col>
    <el-dialog title="Reset password" :visible.sync="showForgotPassword" width="320px">
      <el-form>
        <el-row>
          <el-col :span="24">
            <el-alert
              v-if="sentCode && !$route.query.reset_password_hash"
              :title="$t('We have sent you an activation code to complete your account creation')"
              type="success"
              style="margin-bottom: 10px;">
            </el-alert>
            <el-form-item>
              <el-input size="medium" type="text" :placeholder="$t('Your email')" v-model="emailConfirm"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="!sentCode" :span="24">
            <el-button size="medium" :disable="!canSubmit" :loading="!canSubmit" type="primary" @click="sendResetPassword()">{{ $t('Send code') }}</el-button>
          </el-col>
          <el-col v-else :span="24">
            <el-form-item>
              <el-input size="medium" type="text" :placeholder="$t('Code')" v-model="codeConfirm"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input size="medium" type="password" :placeholder="$t('New Password')" v-model="newPassword"></el-input>
            </el-form-item>
            <el-button size="medium" :disable="!canSubmit" :loading="!canSubmit" type="primary" @click="sendCode()">{{ $t('Confirm') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog :title="$t('Account confirmation')" :visible.sync="showActiveAccount" width="320px">
      <el-form>
        <el-row>
          <el-col :span="24">
            <el-alert
              :title="$t('We have sent you an activation code to complete your account creation')"
              type="success"
              style="margin-bottom: 10px;">
            </el-alert>
            <el-form-item>
              <el-input size="medium" type="text" :placeholder="$t('Email')" v-model="activeInfo.email"></el-input>
              <el-input size="medium" type="text" :placeholder="$t('Input your activation code here')" v-model="activeInfo.active_code"></el-input>
            </el-form-item>
            <div class="action-text">
              <span class="text-center" @click="resendActiveCode()">{{ $t('Resend the activation code') }}</span>
            </div>
            <el-button size="medium" :disable="!canSubmit" :loading="!canSubmit" type="primary" @click="activeAccount()">{{ $t('Confirm') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </el-row>
</template>

<script>
import ls from 'local-storage'
import { mapActions, mapGetters } from 'vuex'
import { login, loginWithProvider, forgotPassword, resetPassword, active, getProfile, resendEmailActive } from '@/api/account'
import facebookLogin from '@/components/app/libraries1/facebook-login'
export default {
  name: 'Login',
  data () {
    return {
      imagePath: process.env.IMAGE_PATH,
      canSubmit: true,
      userInfo: {
        email: '',
        password: ''
      },
      rules: {
        email: [
          { required: true, message: this.$t('Email is required') }
        ],
        password: [
          { required: true, message: this.$t('Password is required') },
          { min: 6, message: this.$t('At least x characters', {x: 6}) }
        ]
      },
      googleSignInParams: {
        client_id: process.env.GOOGLE_LOGIN_KEY
      },
      showForgotPassword: false,
      emailConfirm: '',
      codeConfirm: '',
      newPassword: '',
      sentCode: false,
      activeInfo: {
        active_code: '',
        email: ''
      },
      showActiveAccount: false,
      registerRecently: false
    }
  },
  computed: {
    ...mapGetters(['langs']),
    ...mapGetters('account', ['logged', 'accountInfo', 'activeProjectNumber', 'inactiveProjectNumber'])
  },
  mounted () {
    if (this.logged) {
      this.$router.push({name: 'home-index'})
    }

    // in case user open as reset password link
    if (this.$route.query.reset_password_hash && this.$route.query.email) {
      this.emailConfirm = this.$route.query.email
      this.codeConfirm = this.$route.query.reset_password_hash
      this.sentCode = true
      this.showForgotPassword = true
    }
  },
  methods: {
    ...mapActions('account', ['setAccountInfo', 'checkTotalProjects']),
    registerNow () {
      this.$router.push({name: 'account-register'})
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.canSubmit = false
          login(this.userInfo).then(response => {
            this.canSubmit = true
            switch (response.status) {
              case 1:
                ls('authen', response)
                this.$notify({
                  title: 'Success',
                  message: this.$t('Log in success'),
                  type: 'success'
                })
                getProfile().then(res => {
                  if (res.status === 1) {
                    this.setAccountInfo(res.data)
                    ls.set('user', res.data)
                    if (!res.data.username) {
                      this.$router.push({name: 'account-username'})
                    } else {
                      this.checkFirstLogin(res.data)
                    }
                    this.checkTotalProjects().then((value) => {
                      this.identifyAfterLogin('email')
                    })
                  } else {
                    this.messageError()
                  }
                })
                break
              case 0:
                this.message422(response.errors.message)
                break
              default:
                this.messageError()
                this.$router.push({name: 'account-login'})
                break
            }
          })
        } else {
          this.$notify({
            title: 'Error',
            message: this.$t('Check your information'),
            type: 'warning'
          })
        }
      })
    },
    loginFacebook () {
      const api = facebookLogin({ appId: process.env.FACEBOOK_APP_KEY })
      api.login().then((response) => {
        this.canSubmit = false
        if (response.status === 'connected') {
          loginWithProvider({
            providerId: 'facebook',
            accessToken: response.authResponse.accessToken
          }).then(response => {
            this.canSubmit = true
            switch (response.status) {
              case 1:
                ls('authen', response)
                this.$notify({
                  title: 'Success',
                  message: this.$t('Log in success'),
                  type: 'success'
                })
                getProfile().then(res => {
                  if (res.status === 1) {
                    this.setAccountInfo(res.data)
                    ls.set('user', res.data)
                    if (!res.data.username) {
                      this.$router.push({name: 'account-username'})
                    } else {
                      this.checkFirstLogin(res.data)
                    }
                    this.checkTotalProjects().then(() => {
                      this.identifyAfterLogin('facebook')
                    })
                  } else {
                    this.messageError()
                  }
                })
                break
              case 0:
                this.message422(response.errors.message)
                break
              default:
                this.messageError()
                break
            }
          })
        } else {
          this.canSubmit = true
          this.messageError()
        }
      })
    },
    sendResetPassword () {
      if (this.emailConfirm) {
        this.canSubmit = false
        forgotPassword({email: this.emailConfirm}).then(response => {
          this.canSubmit = true
          switch (response.status) {
            case 1:
              this.sentCode = true
              break
            case 0:
              this.message422(response.errors.message)
              break
            default:
              this.messageError()
              this.emailConfirm = ''
              this.showForgotPassword = false
              break
          }
        })
      }
    },
    resendActiveCode () {
      this.$prompt(this.$t('Please input your email address'), this.$t('Resend your activation code'), {
        confirmButtonText: 'OK',
        cancelButtonText: this.$t('Cancel'),
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: this.$t('Invalid email address')
      }).then(({ value }) => {
        resendEmailActive({email: value}).then(res => {
          switch (res.status) {
            case 1:
              this.$message({
                type: 'success',
                message: this.$t('Activation code sent! Please check your email inbox (or spam folder)')
              })
              break
            case 0:
              this.message422(res.errors.message)
              break
            default:
              this.messageError()
              break
          }
        })
      }).catch(() => {
      })
    },
    sendCode () {
      if (!!this.emailConfirm && !!this.codeConfirm && !!this.newPassword) {
        this.canSubmit = false
        resetPassword({
          email: this.emailConfirm,
          code: this.codeConfirm,
          password: this.newPassword
        }).then(response => {
          this.canSubmit = true
          switch (response.status) {
            case 1:
              this.$notify({
                type: 'success',
                title: 'Success',
                message: this.$t('Sucessful reset! You can log in now')
              })
              this.emailConfirm = ''
              this.codeConfirm = ''
              this.newPassword = ''
              this.sentCode = false
              this.showForgotPassword = false
              break
            case 0:
              this.message422(response.errors.message)
              break
            default:
              this.messageError()
              this.emailConfirm = ''
              this.showForgotPassword = false
              break
          }
        })
      }
    },
    activeAccount () {
      if (this.activeInfo.active_code && this.activeInfo.email) {
        this.canSubmit = false
        active(this.activeInfo).then(response => {
          this.canSubmit = true
          switch (response.status) {
            case 1:
              this.$notify({
                title: this.$t('Activation successful'),
                message: this.$t('You can log in now!'),
                type: 'success'
              })
              this.showActiveAccount = false
              this.$router.push({name: 'account-login'})
              break
            case 0:
              this.message422(response.errors.message)
              break
            default:
              this.messageError()
              this.$router.push({name: 'account-login'})
              break
          }
        })
      }
    },
    setFreshchatUser (user) {
      window.fcWidget.setExternalId(user.username ? user.username : user.email)

      window.fcWidget.user.setFirstName(user.name)
      window.fcWidget.user.setEmail(user.email)
      window.fcWidget.user.setPhone(user.phone)
      if (user.pricing && user.pricing !== undefined && user.pricing.title !== undefined) {
        window.fcWidget.user.setProperties({
          plan: user.pricing.title
        })
      }
    },
    googleSignInSuccess (googleUser) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users
      if (googleUser && googleUser.getAuthResponse(true)) {
        loginWithProvider({
          providerId: 'google',
          accessToken: googleUser.getAuthResponse(true).access_token
        }).then(response => {
          this.canSubmit = true
          switch (response.status) {
            case 1:
              ls('authen', response)
              this.$notify({
                title: 'Success',
                message: this.$t('Log in success'),
                type: 'success'
              })
              getProfile().then(res => {
                if (res.status === 1) {
                  this.setAccountInfo(res.data)
                  ls.set('user', res.data)
                  if (!res.data.username) {
                    this.$router.push({ name: 'account-username' })
                  } else {
                    this.checkFirstLogin(res.data)
                  }
                  this.checkTotalProjects().then(() => {
                    this.identifyAfterLogin('google')
                  })
                } else {
                  this.messageError()
                }
              })
              break
            case 0:
              this.message422(response.errors.message)
              break
            default:
              this.messageError()
              break
          }
        })
      }
    },
    googleSignInError (error) {
      console.log('OH NOES', error)
    },
    checkFirstLogin (user) {
      let firstLog = ls.get('firstLog')
      if ((firstLog === undefined || firstLog === null) && !user.subscriptions.length && !user.subscribed && user.pricing_id === 1) {
        ls.set('firstLog', 1)
        this.$router.push({name: 'account-show', params: {tab: 'subscription'}})
        this.$alert(this.$t('Dear new client. You have successfully created your account and you are entitled for a free trial (Discovery plan). This plan allow you to test our platform. You can decide to upgrade your plan any time in order to enjoy all the features of our solution.', {'user name': user.name}), this.$t('Welcome'), {
          confirmButtonText: 'OK',
          callback: action => {}
        })
      } else {
        this.$router.push({name: 'list-project'})
      }
    },
    changeLanguage (value) {
      ls.set('lang', value)
    },
    identifyAfterLogin (type) {
      if (this.accountInfo && this.accountInfo.id) {
        window.analytics.identify(this.accountInfo.id, {
          name: this.accountInfo.name,
          email: this.accountInfo.email,
          phone: this.accountInfo.phone,
          plan: this.accountInfo.pricing ? this.accountInfo.pricing.title : '',
          role: this.accountInfo.role,
          company: this.accountInfo.company_name,
          avatar: this.accountInfo.avatar ? (this.imagePath + this.accountInfo.avatar) : '',
          activevt: this.activeProjectNumber,
          inactivevt: this.inactiveProjectNumber,
          pastSubscription: (this.accountInfo.subscriptions && this.accountInfo.subscriptions.length) ? this.accountInfo.subscriptions[0] : null,
          created_at: this.accountInfo.created_at,
          lang: this.$i18n ? this.$i18n.locale : 'en'
        })
        window.analytics.track('w-login',
          { type }
        )
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="css" scoped>
  .wrap {
    min-height: 100vh;
    padding: 0px 8px;
    background-color: #2e3a4a;
    display: flex;
    vertical-align: middle;
    justify-content: center;
    color: #fff;
    background-size: cover;
    background-position: center center;
    background-image: url('/static/login_background_mobile.jpg');
  }
  .logo-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .slogan {
    text-align: center;
    line-height: 24px;
    font-size: 18px;
    color: #eeeeee;
    margin-top: 10px;
    margin-bottom: 0px;
  }
  .title {
    text-align: center;
    line-height: 43px;
    font-size: 24px;
    font-weight: 600;
    text-transform: uppercase;
    color: #eeeeee;
    margin-top: 25px;
    margin-bottom: 0px;
  }
  .submit-btn {
    width: 100%;
    border-radius: 8px;
    background-color: #409eff;
    color: #fff;
    border: none;
    font-size: 16px;
    font-weight: 600;
  }
  .text-bottom {
    margin-top: 15px;
    line-height: 19px;
    font-size: 14px;
    font-weight: 300;
    color: #eeeeee;
    cursor: pointer;
  }
  .inner-wrap {
    max-width: 380px;
    height: 510px;
    margin: 50px auto 10px auto;
    padding: 10px 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #00000014;
    border-radius: 5px;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    border: 1px solid #ffffff3b;
  }
  .text-top {
    width: 100%;
  }
  .form-login {
    max-width: 300px;
    padding: 20px 0px 0px 0px;
    margin: 0px auto;
  }
  .fb-btn:hover,
  .fb-btn:focus {
    color: #fff !important;
  }
  .g-signin-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 8px;
    border-radius: 8px;
    background-color: #dc4e41;
    color: #fff;
    height: 33px;
    margin-top: 10px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
  }
  .g-signin-button span {
    margin-left: 5px;
  }
  .lang-btn {
    width: 100px;
    position: absolute;
    top: 10px;
    right: 20px;
  }
  .action-text {
    margin-bottom: 10px;
    cursor: pointer;
    color: #2795d3;
  }
  @media screen and (min-width: 768px) {
    .wrap {
      height: 100vh;
      background-size: cover;
      background-position: bottom right;
      background-image: url('/static/login_background.jpg');
    }
    .inner-wrap {
      margin-top: 0px;
      width: 380px;
      top: calc((100vh - 510px)/2);
      left: calc((100vw/2 - 380px)/2);
      background-color: #00000014;
      position: fixed;
      border-radius: 5px;
      -webkit-backdrop-filter: blur(5px);
      backdrop-filter: blur(5px);
      border: 1px solid #ffffff3b;
    }
    /*Exception for Firefox*/
    @supports (not (-webkit-backdrop-filter: none)) and (not (backdrop-filter: none)) {
      .inner-wrap {
        background-color: #00000059 !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/account/Login.vue